import React from 'react';

const card = {
  background: '#fff',
  borderRadius: 10,
  padding: 24,
  marginBottom: 16,
  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
};

const th = {
  fontSize: 12,
  fontWeight: 600,
  padding: '8px 10px',
  textAlign: 'left',
  background: '#f8fafc',
  borderBottom: '2px solid #e2e8f0',
};

const td = {
  fontSize: 12,
  padding: '7px 10px',
  borderBottom: '1px solid #e2e8f0',
};

const btnSm = {
  fontSize: 12,
  padding: '4px 10px',
  border: '1px solid #e2e8f0',
  borderRadius: 5,
  background: '#f8fafc',
  cursor: 'pointer',
};

const inlineInput = {
  fontSize: 12,
  padding: '4px 6px',
  border: '1px solid #cbd5e1',
  borderRadius: 4,
  width: '100%',
  boxSizing: 'border-box',
};

export default function LoadsTab({
  loads, editingLoad, setEditingLoad,
  addLoad, removeLoad, updateLoad, setLoads,
  NS, aiStatus, DEFAULT_LOADS,
}) {
  return (
    <div style={{ maxWidth: 960, margin: '0 auto' }}>
      {/* AI Success Banner */}
      {aiStatus === 'done' && (
        <div
          style={{
            background: '#dcfce7',
            border: '1px solid #86efac',
            borderRadius: 8,
            padding: '12px 18px',
            marginBottom: 16,
            fontSize: 13,
            color: '#166534',
            fontWeight: 600,
          }}
        >
          Drawing analysis complete -- loads populated from AI results.
        </div>
      )}

      {/* Header bar */}
      <div style={{ ...card, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ fontSize: 13 }}>
          <strong>{loads.length}</strong> load{loads.length !== 1 ? 's' : ''} &nbsp;|&nbsp;
          <strong>{NS}</strong> section{NS !== 1 ? 's' : ''}
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button type="button" onClick={addLoad} style={{ ...btnSm, background: '#eff6ff', color: '#2563eb', fontWeight: 600 }}>
            + Add Load
          </button>
          <button
            type="button"
            onClick={() => setLoads(DEFAULT_LOADS)}
            style={{ ...btnSm, color: '#64748b' }}
          >
            Reset to Default
          </button>
        </div>
      </div>

      {/* Table */}
      <div style={{ ...card, padding: 0, overflow: 'hidden' }}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={th}>#</th>
                <th style={th}>Tag</th>
                <th style={th}>HP</th>
                <th style={th}>NEMA Size</th>
                <th style={th}>Description</th>
                <th style={th}>Notes</th>
                <th style={{ ...th, textAlign: 'center' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loads.map((ld, i) => {
                const editing = editingLoad === i;
                return (
                  <tr
                    key={i}
                    style={{
                      cursor: 'pointer',
                      background: editing ? '#eff6ff' : i % 2 === 0 ? '#fff' : '#fafbfc',
                    }}
                    onClick={() => setEditingLoad(editing ? null : i)}
                  >
                    <td style={{ ...td, color: '#94a3b8', width: 36 }}>{i + 1}</td>
                    <td style={td}>
                      {editing ? (
                        <input
                          style={inlineInput}
                          value={ld.tag || ''}
                          onClick={(e) => e.stopPropagation()}
                          onChange={(e) => updateLoad(i, 'tag', e.target.value)}
                        />
                      ) : (
                        ld.tag || '--'
                      )}
                    </td>
                    <td style={{ ...td, width: 70 }}>
                      {editing ? (
                        <input
                          style={inlineInput}
                          type="number"
                          value={ld.hp ?? ''}
                          onClick={(e) => e.stopPropagation()}
                          onChange={(e) => updateLoad(i, 'hp', Number(e.target.value))}
                        />
                      ) : (
                        ld.hp
                      )}
                    </td>
                    <td style={{ ...td, width: 90 }}>
                      {editing ? (
                        <input
                          style={inlineInput}
                          value={ld.nema || ''}
                          onClick={(e) => e.stopPropagation()}
                          onChange={(e) => updateLoad(i, 'nema', e.target.value)}
                        />
                      ) : (
                        ld.nema || '--'
                      )}
                    </td>
                    <td style={td}>
                      {editing ? (
                        <input
                          style={inlineInput}
                          value={ld.desc || ''}
                          onClick={(e) => e.stopPropagation()}
                          onChange={(e) => updateLoad(i, 'desc', e.target.value)}
                        />
                      ) : (
                        ld.desc || '--'
                      )}
                    </td>
                    <td style={td}>
                      {editing ? (
                        <input
                          style={inlineInput}
                          value={ld.notes || ''}
                          onClick={(e) => e.stopPropagation()}
                          onChange={(e) => updateLoad(i, 'notes', e.target.value)}
                        />
                      ) : (
                        <span style={{ color: '#94a3b8', fontSize: 11 }}>{ld.notes || ''}</span>
                      )}
                    </td>
                    <td style={{ ...td, textAlign: 'center', width: 70 }}>
                      <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); removeLoad(i); }}
                        style={{ ...btnSm, color: '#ef4444', border: 'none', background: 'transparent', fontSize: 14 }}
                        title="Remove load"
                      >
                        x
                      </button>
                    </td>
                  </tr>
                );
              })}
              {loads.length === 0 && (
                <tr>
                  <td colSpan={7} style={{ ...td, textAlign: 'center', color: '#94a3b8', padding: 24 }}>
                    No loads. Click "+ Add Load" to begin.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
